<script lang="ts">
    export let img: {
        url: string;
        srcset: string;
        width: number;
        height: number;
        description: string;
        formatClass: string;
    };
</script>

<section class="grid place-content-center">
    <figure class="flex h-full flex-col gap-1 text-center lg:flex-row figure-wrapper-with-caption">
        <img
            class="w-full shrink object-contain md:w-auto {img.formatClass}"
            src={img.url}
            srcset={img.srcset}
            width={img.width}
            height={img.height}
            alt={img.description}
            loading="lazy"
        />
        <div class="lg:writing-mode-bt max-h-[80vh] text-center text-xs leading-3 lg:py-5 image-description-caption">
            {#if img.description}
                {img.description}
            {/if}
        </div>
    </figure>
</section>

<style>
    .portrait {
        width: 40vw;
    }
    .landscape {
        width: 80vw;
    }
    .image-description-caption {
        position: absolute;
        height: 100%;
        right: 0;
        transform: translateX(150%) rotate(180deg);
    }
    @media screen and (max-width: 1025px) {
        .image-description-caption {
            position: unset !important;
            transform: unset !important;
        }
        .landscape, .portrait {
            width: 100%;
        }
    }
    .figure-wrapper-with-caption {
        position: relative;
    }
</style>